import { RequestContext, GetTitlesInput } from 'DVWebNodeUtils'
import { getEpisodeListPresentationScheme } from '../utils/domainUtils';

export const getTitleInputForEpisodeRefresh = (context: RequestContext, canonicalTitleId: string, isElcano: boolean) => ({
    context,
    titleIDs: [canonicalTitleId],
    fragments: ['Action', 'Refund'],
    presentationScheme: getEpisodeListPresentationScheme(context.domain || 'Fogg'),
    isElcano
} as GetTitlesInput)